/** Fields used for CruiseControl inventory display title (matches /inventory table + vehicle detail header). */
export type VehicleTitleParts = {
  year: number;
  make: string;
  model: string;
  trim?: string | null;
};

export type VehicleTitleWithMileage = VehicleTitleParts & { mileage: number };

/**
 * Internal inventory title: `{year} {make} {model} {trim}` (trim omitted when empty).
 */
export function buildVehicleTitle(parts: VehicleTitleParts): string {
  const trim = parts.trim?.trim();
  return [String(parts.year), parts.make, parts.model, trim && trim.length > 0 ? trim : null]
    .filter((s): s is string => Boolean(s && String(s).trim().length > 0))
    .join(' ');
}

/** Facebook / catalog product title: internal title + mileage clause (no trailing period). */
export function buildFacebookVehicleTitle(parts: VehicleTitleWithMileage): string {
  return `${buildVehicleTitle(parts)} with ${parts.mileage.toLocaleString()} miles`;
}

/** Default `<g:description>` when the vehicle has no stored description (ends with a period). */
export function buildFallbackDescription(parts: VehicleTitleWithMileage): string {
  return `${buildFacebookVehicleTitle(parts)}.`;
}
